export default {
  SUFFIX: 'prod'
  // SUFFIX: 'prod'
  //SUFFIX: 'test'
  // SUFFIX : 'huidu',
  // SUFFIX: 'debug',
}
